export default "__VITE_ASSET__BqpjllWX__"